
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import VueInstaller from 'vue-pwa-installer';
import VueCookie from 'vue-cookies';
import Highcharts from 'highcharts';
import boost from 'highcharts/modules/boost';
import VueHighCharts from 'vue-highcharts';
import VueScreen from 'vue-screen';
import VueYouTubeEmbed from 'vue-youtube-embed';
import VToolTip from 'v-tooltip'

Vue.use(VueCookie);
Vue.use(VueScreen, {
  sm: 480,
  md: '45em',
  lg: '1280px'
});
Vue.use(VueInstaller, {});
Vue.use(VueYouTubeEmbed, {global: true});
Vue.use(VToolTip, {
  // defaultDelay: {show: 1200, hide: 100}
});

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});

Vue.use(VueHighCharts);



// WEBPACK FOOTER //
// ./src/main.js